define('bindingHandlers/editableText',['jquery', 'lib/knockout'], function ($, ko) {
    'use strict';

    /**
     * <p>Binding to allow writing the content of a contenteditable element back to the observable.</p>
     * <p>
     * This binding allows two-way binding of observables
     * to the content of an element, in the style of the "contenteditable" attribute.
     * </p>
     * @exports bindingHandlers/editableText
     */

    function getTextObservable(valueAccessor) {
        var value = valueAccessor();
        if(typeof value === "object") {
            return value.text;
        }
        return value;
    }

    function isEditable(valueAccessor) {
        var value = valueAccessor();
        if(typeof value === "object" && value.isEditable !== undefined) {
            return ko.unwrap(value.isEditable);
        }
        return true; //Always editable
    }

    // Shows watermark even when content is not editable
    function persistentWatermark(valueAccessor) {
        var value = valueAccessor();
        if(typeof value === "object" && value.persistentWatermark !== undefined) {
            return ko.unwrap(value.persistentWatermark);
        }
        return false; // watermark only appears when editable
    }

    ko.bindingHandlers.editableText = {
        init: function (element, valueAccessor) {
            var observable = getTextObservable(valueAccessor);

            $(element).on('focus.editableText', function () {
                $(this).addClass("focused");
            });
            $(element).on('blur.editableText', function () {
                observable($(this).text());
                $(this).removeClass("focused");
            });
            //Prevents non-text from being pasted into contenteditable by intercepting the paste event
            $(element).on('paste.editableText', function (e) {
                e = e.originalEvent;
                //Get the text, depending on browser
                if(e.clipboardData) { //Most browsers
                    e.preventDefault();
                    document.execCommand("insertHTML", false, e.clipboardData.getData("text/plain"));
                } else if(window.clipboardData) { //IE
                    //Attempt to force clipboard to use the plaintext version of its contents
                    window.clipboardData.setData("Text", window.clipboardData.getData("Text"));
                }
            });

            //Update watermark class when text changes
            ko.computed(function () {
                //Display watermark in editmode, when blank
                if(!observable() && (isEditable(valueAccessor) || persistentWatermark(valueAccessor))) {
                    $(element).addClass("watermark");
                } else {
                    $(element).removeClass("watermark");
                }
            }, { disposeWhenNodeIsRemoved: element });

            // Update spellcheck attribute when editable
            ko.computed(function () {
                // spellcheck on when editing, off when not
                if(isEditable(valueAccessor)) {
                    $(element).attr("spellcheck", "true");
                } else {
                    $(element).removeAttr("spellcheck");
                }
            }, { disposeWhenNodeIsRemoved: element });

            var value = valueAccessor();
            if(value.valueUpdate === 'input') {
                var updateHandler = function() {
                    observable($(element).text());
                };

                $(element).on("keyup.editableText", updateHandler);
                $(element).on("input.editableText", updateHandler);
            }

            //Dispose subscription on removal
            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                $(element).off(".editableText");
            });
        },
        update: function (element, valueAccessor) {
            var value = getTextObservable(valueAccessor)();
            if($(element).text() !== value) {
                $(element).text(value);
            }

            //Apply isEditable binding
            $(element).attr('contenteditable', isEditable(valueAccessor));
        }
    };
});

